import React, { memo } from 'react'
import { useHalal, HalalProps } from './useHalal'
import styles from './Halal.module.scss'

const Halal: React.FC<HalalProps> = (props: HalalProps) => {
  const { isBadgeActive } = useHalal(props)

  return (
    <div
      className={`${styles.halal} ${isBadgeActive ? styles['with-badge'] : ''}`}
    >
      <span className={styles.ar}>حلال</span>
      <span className={styles.en}>Halal</span>
    </div>
  )
}

export default memo(Halal)
